<script>
import moment from 'moment';
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CustomerService from '@/services/customer';
import { mask } from 'vue-the-mask'
import { isValidCnpj } from '@/utils/document'

moment.locale('pt-BR');

export default {
  page: {
    title: "Novo Cliente",
  },
  directives: { mask },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Novo Cliente",
      customer: {},
      documentNumberError: false,
    }
  },
  methods: {
    validateDocumentNumber() {
      this.documentNumberError = !!this.customer.documentNumber && !isValidCnpj(this.customer.documentNumber);
    },
    save() {
      if (!this.customer.name || !this.customer.documentNumber || !this.customer.email || !this.customer.phoneNumber || !this.customer.street || !this.customer.number || !this.customer.district || !this.customer.city || !this.customer.state || !this.customer.zipcode) {
        return this.$toast.warning('Preencha todos os campos');
      }

      if (!isValidCnpj(this.customer.documentNumber)) {
        this.documentNumberError = true;
        return this.$toast.warning('CNPJ inválido');
      }

      // CNPJ alfanumérico: normaliza as letras para maiúsculas antes de enviar
      this.customer.documentNumber = this.customer.documentNumber.toUpperCase();

      let loader = this.$loading.show();

      CustomerService.createSellerCustomer(this.customer).then(() => {
        loader.hide();

        this.$toast.open('Cliente cadastrado com sucesso');

        this.$router.push('/seller-customers');
      }).catch((error) => {
        loader.hide();

        if (error.response.data.code && error.response.data.code === 'E9999') {
          return this.$toast.warning(error.response.data.msg, {
            duration: 10000,
          });
        }

        this.$toast.error('Não foi possível cadastrar o cliente');
      })
    }
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="card">
      <div class="card-body">
        <form>
          <div class="row">
            <div class="col-sm-3">
              <div class="form-group">
                <label for="documentNumber">CNPJ</label>
                <input id="documentNumber" name="documentNumber" type="text" class="form-control text-uppercase" :class="{ 'is-invalid': documentNumberError }" v-mask="'XX.XXX.XXX/XXXX-##'" v-model="customer.documentNumber" @blur="validateDocumentNumber" />
                <div v-if="documentNumberError" class="invalid-feedback d-block">CNPJ inválido</div>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label for="name">Razão Social</label>
                <input id="name" name="name" type="text" class="form-control" v-model="customer.name" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-3">
              <div class="form-group">
                <label for="email">E-mail</label>
                <input id="email" name="email" type="email" class="form-control" v-model="customer.email" />
              </div>
            </div>

            <div class="col-sm-2">
              <div class="form-group">
                <label for="phoneNumber">Celular</label>
                <input id="phoneNumber" name="phoneNumber" type="text" class="form-control" v-mask="['(##) ####-####', '(##) #####-####']" v-model="customer.phoneNumber" />
              </div>
            </div>

            <div class="col-sm-2">
              <div class="form-group">
                <label for="phoneNumber2">Telefone Fixo</label>
                <input id="phoneNumber2" name="phoneNumber2" type="text" class="form-control" v-mask="['(##) ####-####', '(##) #####-####']" v-model="customer.phoneNumber2" />
              </div>
            </div>

            <div class="col-sm-2">
              <div class="form-group">
                <label for="stateRegistration">Inscrição Estadual</label>
                <input id="stateRegistration" name="stateRegistration" type="text" class="form-control" v-model="customer.stateRegistration" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-5">
              <div class="form-group">
                <label for="street">Endereço</label>
                <input id="street" name="street" type="text" class="form-control" v-model="customer.street" />
              </div>
            </div>

            <div class="col-sm-1">
              <div class="form-group">
                <label for="number">Número</label>
                <input id="number" name="number" type="tel" class="form-control" v-model="customer.number" v-mask="'######'" />
              </div>
            </div>

            <div class="col-sm-3">
              <div class="form-group">
                <label for="complement">Complemento</label>
                <input id="complement" name="complement" type="text" class="form-control" v-model="customer.complement" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-3">
              <div class="form-group">
                <label for="district">Bairro</label>
                <input id="district" name="district" type="text" class="form-control" v-model="customer.district" />
              </div>
            </div>

            <div class="col-sm-3">
              <div class="form-group">
                <label for="city">Cidade</label>
                <input id="city" name="city" type="text" class="form-control" v-model="customer.city" />
              </div>
            </div>

            <div class="col-sm-1">
              <div class="form-group">
                <label for="complement">UF</label>
                <select class="custom-select" v-model="customer.state">
                  <option value="AC">AC</option>
                  <option value="AL">AL</option>
                  <option value="AP">AP</option>
                  <option value="AM">AM</option>
                  <option value="BA">BA</option>
                  <option value="CE">CE</option>
                  <option value="DF">DF</option>
                  <option value="ES">ES</option>
                  <option value="GO">GO</option>
                  <option value="MA">MA</option>
                  <option value="MT">MT</option>
                  <option value="MS">MS</option>
                  <option value="MG">MG</option>
                  <option value="PA">PA</option>
                  <option value="PB">PB</option>
                  <option value="PR">PR</option>
                  <option value="PE">PE</option>
                  <option value="PI">PI</option>
                  <option value="RJ">RJ</option>
                  <option value="RN">RN</option>
                  <option value="RS">RS</option>
                  <option value="RO">RO</option>
                  <option value="RR">RR</option>
                  <option value="SC">SC</option>
                  <option value="SP">SP</option>
                  <option value="SE">SE</option>
                  <option value="TO">TO</option>
                </select>
              </div>
            </div>

            <div class="col-sm-2">
              <div class="form-group">
                <label for="zipcode">CEP</label>
                <input id="zipcode" name="zipcode" type="tel" class="form-control" v-mask="'#####-###'" v-model="customer.zipcode" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col col-9">
              <label for="note">Observação</label>
              <textarea
                v-model="customer.note"
                name="note"
                class="form-control"
                :maxlength="255"
                rows="3"
                placeholder="Se necessário, adicione alguma informação sobre o cliente"
              ></textarea>
              <div class="text-left">
                <p
                  v-if="customer.note"
                  class="badge position-absolute"
                  :class="{ 'badge-primary': customer.note.length !== 255,
                            'badge-danger': customer.note.length === 255 }"
                >
                  {{ customer.note.length }} /
                  225
                </p>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="row mt-4 mb-4 align-items-center">
      <div class="col-sm-6">
        <button type="button" class="btn btn-primary btn-rounded" @click="save">
          <i class="mdi mdi-check mr-1"></i> Cadastrar Novo Cliente
        </button>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss">
  .search-input form {
    display: flex;
    flex-direction: row;

    .btn {
      margin-left: 10px;
    }
  }
</style>